import type { DropDownProps } from '@myosh/odin-components';
import { DataSearchLocation, DropDown, OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';

interface HfDropDownProps extends DropDownProps {
  control: Control;
  name: string;
}

export default function HfDropDown(props: HfDropDownProps) {
  const {
    control,
    name,
    id,
    textField,
    valueField,
    label,
    value,
    labelInsideDropDown = false,
    selectorStyles,
    allowClear = true,
    allowSearch = true,
    setDefaultValue = false,
    preloadData = false,
    placeholder,
    filterLocation = DataSearchLocation.Local,
    actionItems,
    onActionItemChanged,
    className = 'text-sm',
    dropDownIconSize,
    data,
    readOnly,
    required,
    onDoubleClick,
    onChange,
    fieldValueConverter,
    disabled,
    showAddNewOption,
    shouldUseCreatePortal = false,
    labelStyles,
  } = props;

  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <DropDown
            id={id || 0}
            textField={textField}
            valueField={valueField}
            label={label}
            value={value}
            error={error?.message}
            labelInsideDropDown={labelInsideDropDown}
            allowClear={allowClear}
            allowSearch={allowSearch}
            setDefaultValue={setDefaultValue}
            preloadData={preloadData}
            selectorStyles={selectorStyles}
            data={data}
            placeholder={placeholder}
            filterLocation={filterLocation}
            actionItems={actionItems}
            onActionItemChanged={onActionItemChanged}
            className={className}
            dropDownIconSize={dropDownIconSize}
            onChange={onChange}
            deselectValue={undefined}
            readOnly={readOnly}
            required={required}
            onDoubleClick={onDoubleClick}
            disabled={disabled}
            showAddNewOption={showAddNewOption}
            shouldUseCreatePortal={shouldUseCreatePortal}
            labelStyles={labelStyles}
          />
        );
      }}
    />
  );
}
